// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../hooks/useMergeProps';

import MultimatchItem from './MultimatchItem';
import makeMultimatchItemPropsSelector from './MultimatchItem.selector';

type MultimatchItemContainerProps = {
  className?: string;
  matchId?: number;
};

const MultimatchItemContainer = (ownProps: MultimatchItemContainerProps) => {
  const selectorProps = useMemo(() => ({ matchId: ownProps.matchId }), [ownProps.matchId]);
  const selector = useMemo(() => makeMultimatchItemPropsSelector(), []);
  const selectedProps = useSelector((state) => selector(state, selectorProps));

  const enhancedProps = useMergeProps({
    ownProps,
    selectedProps,
  });

  return <MultimatchItem {...enhancedProps} />;
};

export default MultimatchItemContainer;
